import Reveal from "../components/animations/Reveal";
import React from "react";
import NineSeeMore from "../components/NineSeeMore";
import TitleHeading from "../components/TitleHeading";
import { getNewsPagination } from "../helpers/Api/apiHelper";
import MuiSkeleton from "../components/MuiSkeleton";
import { useTranslation } from "react-i18next";

function News() {
    document.title = 'News | Shan De'; 
    const [newsData, setNewsData] = React.useState(null);
    const [page, setPage] = React.useState(0);
    const [totalPage, setTotalPage] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const {t} = useTranslation();

    const getNews = async (pageNo) => {
        const response = await getNewsPagination(pageNo)
        if(response) {
            if(response.success) {
                setTotalPage(response.success.totalPage)
                if(newsData != null) {
                    setNewsData(newsData.concat(response.success.data));
                    setLoading(false);
                }
                else {
                    setNewsData(response.success.data);
                    setLoading(false);
                }
            }
            else {
                console.log(response.error);
                setNewsData(null);
                setLoading(false);
            }
        }
        else {
            setNewsData(null);
            setLoading(false);
        }
    }
    React.useEffect(() => {
        getNews(page);
    },[page])

    const addExtraPage = () => {
        if(totalPage) {
            if((page + 1) < totalPage) {
                setPage(page + 1);
            }
        }
    }
    if(loading) return (
        <div className="container">
            <TitleHeading 
            title = {t("news")}
            className = "text-center pt-5"
            />
            <MuiSkeleton skeletonAmount = {9} />
        </div>
    )
    if(newsData)
    return (
        <div className="container">
            <TitleHeading 
            title = {t("news")}
            className = "text-center pt-5"
            />
            <NineSeeMore 
            data = {newsData}
            page = "news"
            />
            {
                totalPage && page + 1 < totalPage
                ?
                <Reveal className="text-center" y={20}>
                    <button type = "button" className="btn_see_more mb-3" onClick={addExtraPage}>
                        {t("loadMore")}
                    </button>
                </Reveal>
                : ""
            }
        </div>
    )
}
export default News;